'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaRouble = function FaRouble(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.8 12.6q0-2.2-1.5-3.6t-3.8-1.4h-7.1v10h7.1q2.4 0 3.8-1.4t1.5-3.6z m5.3 0q0 4.3-2.9 7t-7.2 2.8h-7.6v2.6h11.2q0.4 0 0.6 0.2t0.2 0.5v2.9q0 0.3-0.2 0.5t-0.6 0.2h-11.2v4.3q0 0.3-0.2 0.5t-0.5 0.2h-3.8q-0.3 0-0.5-0.2t-0.2-0.5v-4.3h-5q-0.3 0-0.5-0.2t-0.2-0.5v-2.9q0-0.3 0.2-0.5t0.5-0.2h5v-2.6h-5q-0.3 0-0.5-0.2t-0.2-0.6v-3.3q0-0.3 0.2-0.5t0.5-0.2h5v-14q0-0.3 0.2-0.5t0.5-0.2h12.1q4.4 0 7.2 2.7t2.9 7z' })
        )
    );
};

exports.default = FaRouble;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/rouble.js
// module id = 1940
// module chunks = 168707334958949